import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormularioDepartamentoComponent } from './formulario-departamento/formulario-departamento.component';
import { CatalogoDepartamentoService } from '@services/catalogo/catalogoDepartamento.service';
import { DepartamentoModel } from '@/store/catalogos/departamento';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-departamentos',
  templateUrl: './departamentos.component.html',
  styles: [
  ]
})
export class DepartamentosComponent {
  PROP = properties;
  displayedColumns: string[] = ['nombre', 'jefe', 'options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private departamentoService: CatalogoDepartamentoService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this. loadDepartamentos();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadDepartamentos() {
    this.departamentoService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioDepartamentoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:null}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadDepartamentos();
      }
    });
  }

  update(row: DepartamentoModel) {
    const dialogRef = this.dialog.open(FormularioDepartamentoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:true,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadDepartamentos();
      }
    });
  }

  view(row: DepartamentoModel) {
    const dialogRef = this.dialog.open(FormularioDepartamentoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:false,view:true,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadDepartamentos();
      }
    });
  }


}